import { Button } from '@cloudflare/kumo';
import type { FormEvent } from 'react';
import { ICONS } from '../ui/icons';
import { ACCEPT, MAX_FILES, type JevChat } from './useJevChat';
import '../../styles/jev.css';

/** Caixa de mensagem da Lumi: anexos de texto, `@` para marcar registros e envio com Enter. */
export function JevComposer({ chat, className = 'jev-panel__input', placeholder, rows = 2, onSend }: {
  chat: JevChat; className?: string; placeholder?: string; rows?: number; onSend?: (text: string) => void;
}) {
  const { input, options, files, fileNote, busy, fileRef, inputRef, onInput, pickMention, addFiles, setFiles, setOptions } = chat;
  const send = (text: string) => (onSend ? onSend(text) : chat.send(text));
  const submit = (e: FormEvent) => { e.preventDefault(); send(input); };

  return (
    <form className={className} onSubmit={submit}>
      {options.length > 0 && (
        <ul className="jev-mentions" role="listbox" aria-label="Registros">
          {options.map((o) => (
            <li key={`${o.type}:${o.id}`}>
              <button type="button" role="option" aria-selected="false" onClick={() => pickMention(o)}>
                <span>{o.label}</span><small>{o.hint}</small>
              </button>
            </li>
          ))}
        </ul>
      )}
      {(files.length > 0 || fileNote) && (
        <div className="jev-files">
          {files.map((f) => (
            <span key={f.name} className="jev-file"><ICONS.Paperclip size={14} />{f.name}
              <button type="button" aria-label={`Remover ${f.name}`} onClick={() => setFiles((x) => x.filter((y) => y.name !== f.name))}><ICONS.X size={12} /></button>
            </span>
          ))}
          {fileNote && <span className="jev-muted" role="status">{fileNote}</span>}
        </div>
      )}
      <div className="jev-panel__row">
        <input ref={fileRef} type="file" accept={ACCEPT} multiple hidden onChange={(e) => addFiles(e.target.files)} />
        <Button type="button" variant="ghost" shape="square" icon={ICONS.Paperclip} aria-label="Anexar arquivo de texto" disabled={busy || files.length >= MAX_FILES} onClick={() => fileRef.current?.click()} />
        <textarea
          ref={inputRef}
          aria-label="Mensagem para a Lumi"
          placeholder={placeholder ?? 'Pergunte, peça uma ação ou digite @ para marcar um registro…'}
          value={input}
          rows={rows}
          maxLength={4000}
          disabled={busy}
          onChange={(e) => onInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape' && options.length) { e.stopPropagation(); setOptions([]); return; }
            if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (options.length) pickMention(options[0]); else send(input); }
          }}
        />
        <Button type="submit" variant="primary" shape="square" icon={ICONS.ArrowRight} aria-label="Enviar" disabled={busy || !input.trim()} />
      </div>
    </form>
  );
}
